import { render, staticRenderFns } from "./ShareOnes.vue?vue&type=template&id=6bbd61a6&scoped=true"
import script from "./ShareOnes.vue?vue&type=script&lang=js"
export * from "./ShareOnes.vue?vue&type=script&lang=js"
import style0 from "./ShareOnes.vue?vue&type=style&index=0&id=6bbd61a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbd61a6",
  null
  
)

export default component.exports